import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
// redux
import { useSelector } from '../../../redux/store';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ 
  isCollapse,
}) {
  const { user, store } = useSelector((state) => state.account);
  
  return (
    <Link 
      underline="none" 
      color="inherit" 
      component={RouterLink} 
      to={PATH_DASHBOARD.account.general}
      // sx={{
      //   pointerEvents: user.setup_wizard_state === 5 ? 'none' : 'all' 
      // }}
    >
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
        <Avatar alt="LEVAR User" src={store?.c_logo}/>

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
            maxWidth: 140
          }}
        >
          <Typography variant="subtitle2" noWrap sx={{ maxWidth: 125 }}>
            {/* {user.first_name} {user.last_name} */}
            {user.email}
          </Typography>
          <Typography variant="body2" noWrap sx={{ color: 'text.secondary', maxWidth: 120 }}>
            {store.store_title}
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
